<div class="uk-section-default uk-section uk-section-xsmall uk-padding-remove-bottom" style="min-height: 325px">
  <div class="uk-container uk-container-expand">
    <div class="uk-grid-margin uk-grid uk-grid-stack" uk-grid="">
      <div class="uk-width-1-1@m uk-first-column">


        <div class="uk-margin-medium-bottom">
          <div class="uk-grid">


            <!-- MIDDLE -->
            <div class=" uk-width-expand@m">

              @if (errorMessage) {
                <div class="uk-alert uk-alert-danger">{{errorMessage}}</div>
              }

              <div class="uk-flex uk-flex-right">
                <form [formGroup]="dataForm" (ngSubmit)="handleChangeAndResetPage()" class="uk-search uk-search-default" style="width: 250px;">
                  <span uk-search-icon></span>
                  <input class="uk-search-input" type="search" placeholder="Search..." formControlName="query">
                </form>
              </div>

              <div class="uk-grid uk-margin-top">

                <div class="uk-width-1-4">

                  <h4>Filters</h4>

                  <hr class="uk-margin-large-right">

                  @if (facets !== null && facets !== undefined && facets[0]?.values) {
                    <div class="refineCategory uk-grid-margin">
                      <h3 class="uk-h3">Vocabularies</h3>
                      <!--                    <label class="uk-margin-small-left uk-margin-medium-bottom">-->
                      <!--                      <input class="uk-search-input" [(ngModel)]="searchFacet" placeholder="Search with provider id or provider name">-->
                    <!--                    </label>-->
                    @for (vocabulary of facets[0].values; track vocabulary) {
                      <div class="uk-margin-small-top">
                        @if (!searchFacet || searchFacet.toLowerCase() === vocabulary.value.toLowerCase()
                          || (vocabulary.label!=null && vocabulary.label.toLowerCase().includes(searchFacet.toLowerCase()))) {
                          <div>
                            <label class="uk-margin-small-left">
                              <input class="uk-checkbox" type="checkbox" name="filter" value="vocabulary" data-md-icheck
                                (change)="this.onSelection($event, 'vocabulary', vocabulary.value)"
                                [checked]="isProviderChecked(vocabulary.value)">
                            </label>
                            <span> {{ vocabulary.label | titlecase }}</span>
                            <span> ({{vocabulary.count}})</span>
                          </div>
                        }
                      </div>
                    }
                  </div>
                } @else {
                  <div>No filters found.</div>
                }


              </div>

              <div class="uk-width-3-4">

                <form [formGroup]="dataForm" class="uk-form-horizontal uk-flex uk-flex-middle filters">

                  <div class="uk-margin-right">
                    <div class="">
                      <label class="" for="quantity">Results per page </label>
                      <div class="uk-inline">
                        <select class="uk-input uk-select" id="quantity" (change)="handleChangeAndResetPage()" formControlName="quantity">
                          <option value="10" selected>10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div class="uk-margin-right">

                    <div class="uk-inline uk-margin-right">
                      <label class="" for="order">Order </label>
                      <div class="uk-inline">
                        <select class="uk-input uk-select" id="order" (change)="handleChangeAndResetPage()" formControlName="order">
                          <option value="ASC">Ascending</option>
                          <option value="DESC" selected>Descending</option>
                        </select>
                      </div>
                    </div>

                    <div class="uk-inline">
                      <label class="" for="sort">Sort by </label>
                      <div class="uk-inline">
                        <select class="uk-input uk-select" id="sort" (change)="handleChangeAndResetPage()" formControlName="sort">
                          <!--                            <option value="name">Name</option>-->
                          <option value="dateOfRequest" selected>Creation Date</option>
                          <option value="resolutionDate">Modification Date</option>
                          <!--                            <option value="id">ID</option>-->
                        </select>
                      </div>
                    </div>

                  </div>

                  <div class="uk-margin-right">
                    <div class="uk-inline uk-margin-right">
                      <label class="" for="status">Status </label>
                      <div class="uk-inline">
                        <select class="uk-input uk-select" id="status" (change)="handleChangeAndResetPage()" formControlName="status">
                          <option value="Pending,Approved,Rejected">All</option>
                          <option value="Pending" selected>Pending</option>
                          <option value="Approved">Approved</option>
                          <option value="Rejected">Rejected</option>
                        </select>
                      </div>
                    </div>
                  </div>

                </form>

                @if (loadingMessage) {
                  <div class="uk-margin-large-top">
                    <div class="loader-big"></div>
                  </div>
                }

                @if (!loadingMessage && (!vocabularyCurations || (vocabularyCurations.length==0))) {
                  <div class="uk-margin-large-top">
                    No resources found for your selections.
                  </div>
                }

                @if (vocabularyCurations && (vocabularyCurations.length>0)) {
                  <div id="serviceForm" class="uk-margin-medium-top">
                    <div class="uk-flex uk-flex-middle uk-flex-between">
                      <div class="resultsInfo">
                        <span class="number">{{total}}</span> RESULTS, PAGE <span class="number">{{currentPage}}</span> OF <span class="number">{{pageTotal}}</span>
                      </div>
                      <ul class="uk-pagination">
                        @if (currentPage>2 && pageTotal>5) {
                          <li><a (click)="goToPage(1)"><span uk-pagination-previous></span><span uk-pagination-previous></span></a></li>
                        }
                        @if (currentPage!==1) {
                          <li><a (click)="previousPage()"><span uk-pagination-previous></span></a></li>
                        }
                        @for (i of pages; track i) {
                          <li [ngClass]="i === currentPage ? 'uk-active': ''">
                            <a (click)="goToPage(i)">{{i}}</a>
                          </li>
                        }
                        @if (currentPage!==pageTotal) {
                          <li><a (click)="nextPage()"><span uk-pagination-next></span></a></li>
                        }
                        @if (currentPage<pageTotal-1 && pageTotal>5) {
                          <li><a (click)="goToPage(pageTotal)"><span uk-pagination-next></span><span uk-pagination-next></span></a></li>
                        }
                      </ul>
                    </div>
                    <hr class="adminResultsHeader">
                    @for (curation of vocabularyCurations; track curation) {
                      <div class="uk-card provider-card uk-margin-medium-top">
                        <div class="uk-card-body" style="padding-bottom: 20px;">
                          @if (curation.status === 'Pending') {
                            <div class="pending">
                              <div class="uk-card-badge uk-label">Pending</div>
                            </div>
                          }
                          @if (curation.status === 'Approved') {
                            <div class="approved">
                              <div class="uk-card-badge uk-label">Approved</div>
                            </div>
                          }
                          @if (curation.status === 'Rejected') {
                            <div class="rejected">
                              <div class="uk-card-badge uk-label">Rejected</div>
                            </div>
                          }
                          <div class="">
                            <div class="uk-grid">
                              <div class="uk-width-1-5">
                                <!--                              <div>-->
                                <!--                                <img class="el-image uk-border-rounded"-->
                                <!--                                     src="{{ curation.logo ? curation.logo : '/assets/images/broken_image-black-48dp.svg' }}">-->
                              <!--                              </div>-->
                            </div>
                            <div class="uk-width-3-5">
                              <div class="providerName">
                              </div>
                              <div class="">
                                <span class="statusLabel">Entry Value Name: </span>{{ curation.entryValueName }}
                              </div>
                              <div class="uk-margin-small-top">
                                <span class="statusLabel">Vocabulary: </span>{{ curation.vocabulary | titlecase }}
                              </div>
                              <div class="uk-margin-small-top">
                                <span class="statusLabel">Parent: </span>{{ curation.parent ? curation.parent : 'None' }}
                              </div>
                              <div class="uk-margin-small-top">
                                <span class="statusLabel">Resource Type: </span>{{ curation.vocabularyEntryRequests[0].resourceType | titlecase }}
                              </div>
                              <div class="uk-margin-small-top">
                                <span class="statusLabel">Creation Date: </span>{{ curation.vocabularyEntryRequests[0].dateOfRequest | date }}
                              </div>
                              <div class="uk-margin-small-top">
                                <span class="statusLabel">Modification Date: </span>{{ curation.resolutionDate ?  (curation.resolutionDate | date) : 'Pending' }}
                              </div>
                              <!--                              <div class="uk-margin-small-top">-->
                              <!--                                <span class="statusLabel">Status: </span>{{ curation.status }}-->
                            <!--                              </div>-->
                          </div>
                          <div class="uk-width-1-5">
                            @if (curation.status === 'Pending') {
                              <div class="action-buttons" style="padding: 10px 0 10px 20px;">
                                <button (click)="approvalModal(curation)"
                                  class="uk-button uk-button-primary uk-display-block uk-margin-medium-top">
                                  <i class="fa fa-thumbs-up fa-lg" aria-hidden="true"></i> Approve Entry
                                </button>
                                <button (click)="rejectionModal(curation)"
                                  class="uk-button uk-button-danger uk-display-block uk-margin-small-top">
                                  <i class="fa fa-thumbs-down fa-lg" aria-hidden="true"></i> Reject Entry
                                </button>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                      <ng-container>
                        <hr class="uk-margin-top">
                        <button class="uk-button uk-button-link" (click)="viewMoreModal(curation)">
                          <i class="uk-margin-small-left fa fa-eye"></i> View more
                        </button>
                      </ng-container>
                    </div>
                  </div>
                }
                <ul class="uk-pagination uk-flex-right uk-margin">
                  @if (currentPage>2 && pageTotal>5) {
                    <li><a (click)="goToPage(1)"><span uk-pagination-previous></span><span uk-pagination-previous></span></a></li>
                  }
                  @if (currentPage!==1) {
                    <li><a (click)="previousPage()"><span uk-pagination-previous></span></a></li>
                  }
                  @for (i of pages; track i) {
                    <li [ngClass]="i === currentPage ? 'uk-active': ''">
                      <a (click)="goToPage(i)">{{i}}</a>
                    </li>
                  }
                  @if (currentPage!==pageTotal) {
                    <li><a (click)="nextPage()"><span uk-pagination-next></span></a></li>
                  }
                  @if (currentPage<pageTotal-1 && pageTotal>5) {
                    <li><a (click)="goToPage(pageTotal)"><span uk-pagination-next></span><span uk-pagination-next></span></a></li>
                  }
                </ul>
              </div>
            }

          </div>

        </div>


      </div>
    </div>


  </div>
</div>
</div>
</div>
</div>

<div id="spinnerModal" uk-modal>
  <div class="loader-small" style="text-align: center; padding-top: 170px; color: rgb(47, 64, 80); font-weight: bold;">
  </div>
</div>

<div id="approvalModal" uk-modal>
  @if (!loadingMessage) {
    <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
      @if (selectedCuration) {
        <div>
          <h6>Are you sure you want to approve this vocabulary entry?</h6>
          <!--      <p>Are you sure you want to approve this vocabulary entry?</p>-->
        </div>
      }
      <button class="uk-button uk-button-primary uk-modal-close" type="button" (click)="approveAction()">Proceed</button>
      <button class="uk-button uk-button-default uk-modal-close" type="button">Cancel</button>
    </div>
  }
  @if (loadingMessage) {
    <div>
      <div class="loader-small" style="text-align: center; padding-top: 170px; color: rgb(47, 64, 80); font-weight: bold;">
        {{ loadingMessage }}
      </div>
      <!--    <div class="whiteFilm"></div>-->
    </div>
  }
</div>

<div id="rejectionModal" uk-modal>
  @if (!loadingMessage) {
    <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
      @if (selectedCuration) {
        <div>
          <h6>Are you sure you want to reject this vocabulary entry?</h6>
          <form>
            <!--        <p>Reason of rejection (optional)</p>-->
            <div class="uk-margin">
              <label>
                <input class="uk-input uk-form-width-large" type="text" id="reasonOfRejection" placeholder="Reason of rejection (optional)">
              </label>
            </div>
            <button class="uk-button uk-button-primary uk-modal-close" type="button" (click)="rejectAction()">Proceed</button>
            <button class="uk-button uk-button-default uk-modal-close" type="button">Cancel</button>
          </form>
        </div>
      }
    </div>
  }
  @if (loadingMessage) {
    <div>
      <div class="loader-small" style="text-align: center; padding-top: 170px; color: rgb(47, 64, 80); font-weight: bold;">
        {{ loadingMessage }}
      </div>
      <!--    <div class="whiteFilm"></div>-->
    </div>
  }
</div>

<div id="viewMoreModal" uk-modal>
  @if (!loadingMessage) {
    <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
      @if (selectedVocabularyEntryRequests && selectedCuration) {
        <div>
          <h6><span style="color: #808080">Details regarding vocabulary entry request: </span>{{ this.selectedCuration.entryValueName }}</h6>
          <h6 class="uk-margin-medium-bottom"><span style="color: #808080">Vocabulary: </span>{{ this.selectedCuration.vocabulary | titlecase }}</h6>
          @for (entry of selectedVocabularyEntryRequests; track entry) {
            <div>
              <div><span style="color: #808080">User Id: </span>{{ entry.userId }}</div>
              <div><span style="color: #808080">Creation Date: </span>{{ entry.dateOfRequest | date }}</div>
              <div><span style="color: #808080">Resource Type: </span>{{ entry.resourceType | titlecase }}</div>
              <div><span style="color: #808080">Provider Id: </span>{{ entry.providerId }}</div>
              <div><span style="color: #808080">Resource Id: </span>{{ entry.resourceId }}</div>
              <br>
              </div>
            }
          </div>
        }
        <button class="uk-button uk-button-secondary uk-modal-close uk-align-right" type="button">Close</button>
      </div>
    }
    @if (loadingMessage) {
      <div>
        <div class="loader-small" style="text-align: center; padding-top: 170px; color: rgb(47, 64, 80); font-weight: bold;">
          {{ loadingMessage }}
        </div>
        <!--    <div class="whiteFilm"></div>-->
      </div>
    }
  </div>
